﻿const axios = require('axios');

class AlertBox {
    Init() {
        var inst = this;
        $('.alert-box__close').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.hideAlert($(this));
            });
        });
    }

    hideAlert(e) {
        let bodyFormData = "";
        axios({
            method: 'post',
            url: "/HeaderBlock/HideAlert",
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .finally(function () {
                $("#alertBox").hide(500);
            });
    }
}

var alertBox = new AlertBox();
alertBox.Init();